import { lazy } from 'react'

export const ThankYouVariant1 = lazy(() => import('./ThankYouVariant1'))
